import { useAdminStore } from '@/shared/model/AdminStore';
import type React from 'react';
import { useEffect } from 'react';

export const TimezoneDetector: React.FC = () => {
  const updateTimezone = useAdminStore(state => state.updateTimezone);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        updateTimezone();
      }
    };

    const handleFocus = () => {
      updateTimezone();
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('focus', handleFocus);
    updateTimezone();

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('focus', handleFocus);
    };
  }, [updateTimezone]);

  return <></>;
};

export default TimezoneDetector;
